<template>
  <div class="role-and-permissions">
    <h4>Roles Manager - FED Service Awards</h4>
    <p>
      Use this screen to see permission details of available system roles and to create and manage custom roles.
    </p>
    <div class="row">
      <div class="col-xs-12 col-sm-6 col-md-2 col-lg-2">
        <b-button :to="{ name: 'AdminSettingsRoleAndPermissionsAdd' }" class="buttonStyle my-2" variant="primary"> Add Role</b-button>
      </div>
      <div class="col-xs-12 col-sm-6 col-md-2 col-lg-4">
        <b-button :to="{ name: 'AdminSettingsRoleAndPermissionsManageRoles' }" class="buttonStyle my-2" variant="primary">
          Manage User Roles</b-button
        >
      </div>
    </div>
    <hr />
    <div class="d-flex my-2" style="flex-direction: column;">
      <h6>Default System Roles</h6>
      <div class="row my-4">
        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 d-flex" style="align-items:center;">
          <p style="white-space: nowrap;" class="m-0">Records per Screen</p>
          <b-form-select
            style="max-width: 20%;"
            class="ml-2"
            v-model="filterRecordsPerScreen"
            :options="filterRecordsPerScreenOptions"
            @change="onChangeRecordsPerScreen()"
          ></b-form-select>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 text-right">
          <p class="m-0">
            <span class="text-success">{{ getDefaultSystemRolesObj.selectedRecordCount }}</span>
            RECORDS FOUND
          </p>
        </div>
      </div>
      <b-table
        responsive
        class="border table table-striped table-hover"
        :items="getDefaultSystemRolesObj.Result"
        :fields="defaultSystemRolesFields"
        :busy="isBusyDefault"
        show-empty
      >
        <template #table-busy>
          <div class="text-center my-2" style="color: #0d6efd">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="mx-1">Processing...</strong>
          </div>
        </template>
        <template #empty="">
          <div class="text-center my-2" style="color: #0d6efd">
            <strong class="mx-1">No data found.</strong>
          </div>
        </template>
        <template v-slot:cell(role_name)="data">
          <b>{{ data.item.name }}:</b>
          <span> {{ data.item.description }}</span>
        </template>
        <template v-slot:cell(permissions)="data">
          <p>{{ data.item.module_count }} Modules, {{ data.item.sub_module_count }} Submodules</p>
        </template>
        <template v-slot:cell(actions)="data">
          <b-button
            size="sm"
            class="buttonStyle my-2"
            variant="primary"
            @click="
              openSettingModal({
                clientRoleId: data.item.client_role_id,
                clientId: data.item.client_id,
                roleId: data.item.role_id,
                name: data.item.name,
                description: data.item.description,
                isCustom: data.item.is_custom,
                allowAdminAccess: data.item.allow_admin_access,
                overwriteUnitRoles: data.item.overwrite_unit_roles,
              })
            "
          >
            Details</b-button
          >
        </template>
      </b-table>
      <div class="row" v-if="getDefaultSystemRolesObj.Result.length > 0">
        <div class="col-xs-12 col-sm-12 col-lg-6 col-md-6">
          <label
            >Viewing
            {{ filterRecordsPerScreen * getDefaultSystemRolesObj.pageNumber - filterRecordsPerScreen + 1 }}
            -
            {{
                      filterRecordsPerScreen * getDefaultSystemRolesObj.pageNumber &lt;= getDefaultSystemRolesObj.selectedRecordCount
                        ? filterRecordsPerScreen * getDefaultSystemRolesObj.pageNumber
                        : getDefaultSystemRolesObj.selectedRecordCount
            }}
            of {{ getDefaultSystemRolesObj.selectedRecordCount }} records</label
          >
        </div>
        <div class="col-sm-12 col-lg-6 col-md-6">
          <b-button-group class="float-right">
            <b-button @click="firstPagination()" :disabled="firstPageDefault === getDefaultSystemRolesObj.pageNumber">&#60;&#60;</b-button>
            <b-button @click="prevPagination()" :disabled="firstPageDefault === getDefaultSystemRolesObj.pageNumber">Prev</b-button>
            <b-button>{{ getDefaultSystemRolesObj.pageNumber }}</b-button>
            <b-button
              @click="nextPagination()"
              :disabled="Math.ceil(getDefaultSystemRolesObj.selectedRecordCount / filterRecordsPerScreen) === getDefaultSystemRolesObj.pageNumber"
              >Next</b-button
            >
            <b-button
              @click="lastPagination()"
              :disabled="Math.ceil(getDefaultSystemRolesObj.selectedRecordCount / filterRecordsPerScreen) === getDefaultSystemRolesObj.pageNumber"
              >>></b-button
            >
          </b-button-group>
        </div>
      </div>
    </div>
    <hr />
    <div class="d-flex my-2" style="flex-direction: column;">
      <h6>Custom Roles</h6>
      <div class="row my-4">
        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 d-flex" style="align-items:center;">
          <p style="white-space: nowrap;" class="m-0">Records per Screen</p>
          <b-form-select
            style="max-width: 20%;"
            class="ml-2"
            v-model="filterRecordsPerScreenCustom"
            :options="filterRecordsPerScreenOptions"
            @change="onChangeRecordsPerScreenCustom()"
          ></b-form-select>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 text-right">
          <p class="m-0">
            <span class="text-success">{{ getCustomSystemRolesObj.selectedRecordCount }}</span>
            RECORDS FOUND
          </p>
        </div>
      </div>
      <b-table
        responsive
        class="border table table-striped table-hover"
        :items="getCustomSystemRolesObj.Result"
        :fields="customRolesFields"
        :busy="isBusyCustom"
        show-empty
      >
        <template #table-busy>
          <div class="text-center my-2" style="color: #0d6efd">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="mx-1">Processing...</strong>
          </div>
        </template>
        <template #empty="">
          <div class="text-center my-2" style="color: #0d6efd">
            <strong class="mx-1">No data found.</strong>
          </div>
        </template>
        <template v-slot:cell(role_name)="data">
          <b>{{ data.item.name }}:</b>
          <span> {{ data.item.description }}</span>
        </template>
        <template v-slot:cell(permissions)="data">
          <p>{{ data.item.module_count }} Modules, {{ data.item.sub_module_count }} Submodules</p>
        </template>
        <template v-slot:cell(actions)="data">
          <b-button-group size="sm" type="button">
            <b-button
              size="sm"
              class="buttonStyle my-2"
              variant="primary"
              :value="data.item.role_id"
              @click="
                openSettingModal({
                  clientRoleId: data.item.client_role_id,
                  clientId: data.item.client_id,
                  roleId: data.item.role_id,
                  name: data.item.name,
                  description: data.item.description,
                  isCustom: data.item.is_custom,
                  allowAdminAccess: data.item.allow_admin_access,
                  overwriteUnitRoles: data.item.overwrite_unit_roles,
                })
              "
            >
              Details</b-button
            >
            <b-button
              size="sm"
              class="buttonStyle my-2 mx-1"
              variant="primary"
              :to="{
                name: 'AdminSettingsRoleAndPermissionsEdit',
                params: { clientRoleId: data.item.client_role_id },
              }"
            >
              Edit</b-button
            >
            <b-button
              size="sm"
              class="buttonStyle my-2"
              variant="primary"
              :value="data.item.role_id"
              @click="deleteClientRoleByClientRoleId(data.item.client_role_id)"
            >
              Delete</b-button
            >
          </b-button-group>
        </template>
      </b-table>
      <div class="row" v-if="getCustomSystemRolesObj.Result.length > 0">
        <div class="col-xs-12 col-sm-12 col-lg-6 col-md-6">
          <label
            >Viewing
            {{ filterRecordsPerScreenCustom * getCustomSystemRolesObj.pageNumber - filterRecordsPerScreenCustom + 1 }}
            -
            {{
                      filterRecordsPerScreenCustom * getCustomSystemRolesObj.pageNumber &lt;= getCustomSystemRolesObj.selectedRecordCount
                        ? filterRecordsPerScreenCustom * getCustomSystemRolesObj.pageNumber
                        : getCustomSystemRolesObj.selectedRecordCount
            }}
            of {{ getCustomSystemRolesObj.selectedRecordCount }} records
          </label>
        </div>
        <div class="col-sm-12 col-lg-6 col-md-6">
          <b-button-group class="float-right">
            <b-button @click="firstPaginationCustom()" :disabled="firstPageCustom === getCustomSystemRolesObj.pageNumber">&#60;&#60;</b-button>
            <b-button @click="prevPaginationCustom()" :disabled="firstPageCustom === getCustomSystemRolesObj.pageNumber">Prev</b-button>
            <b-button>{{ getCustomSystemRolesObj.pageNumber }}</b-button>
            <b-button
              @click="nextPaginationCustom()"
              :disabled="Math.ceil(getCustomSystemRolesObj.selectedRecordCount / filterRecordsPerScreenCustom) === getCustomSystemRolesObj.pageNumber"
              >Next</b-button
            >
            <b-button
              @click="lastPaginationCustom()"
              :disabled="Math.ceil(getCustomSystemRolesObj.selectedRecordCount / filterRecordsPerScreenCustom) === getCustomSystemRolesObj.pageNumber"
              >>></b-button
            >
          </b-button-group>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AdminSettingsRoleAndPermissionsList',
  data() {
    return {
      defaultSystemRolesFields: [
        {
          key: 'role_name',
          sortable: true,
        },
        {
          key: 'permissions',
          sortable: true,
        },
        {
          key: 'actions',
          sortable: true,
        },
      ],
      customRolesFields: [
        {
          key: 'role_name',
          sortable: true,
        },
        {
          key: 'permissions',
          sortable: true,
        },
        {
          key: 'actions',
          sortable: true,
        },
      ],
      filterRecordsPerScreen: 5,
      filterRecordsPerScreenCustom: 5,
      firstPageDefault: 1,
      firstPageCustom: 1,
      pageNoDefault: 1,
      pageNoCustom: 1,
      isBusyDefault: false,
      isBusyCustom: false,
    };
  },
  methods: {
    openSettingModal(data) {
      // opening modal
      this.$store.commit('systemMessage/SET_SETTINGS_MODAL_FLAG', true);

      // // storing role, description, custom, admin access, overwrite unit roles in settings store
      this.$store.commit('settings/SET_SETTINGS_MODAL_DETAILS_BY_ID', data);

      var params = {
        clientRoleId: data.clientRoleId,
        clientId: data.clientId,
      };

      this.$store
        .dispatch('settings/fetchClientRoleModules', params)
        .then(() => {})
        .catch(() => {
          console.log('error from openSettingModal');
        });
    },
    onChangeRecordsPerScreen() {
      // setting spinner to true
      this.isBusyDefault = true;

      var newDefaultSystemRolesObj = this.getDefaultSystemRolesObj;
      newDefaultSystemRolesObj.pageSize = this.filterRecordsPerScreen;

      // update settings store getDefaultSystemRolesObj
      this.$store.commit('settings/SET_DEFAULT_SYSTEM_ROLES_OBJ', newDefaultSystemRolesObj);

      // calling the get all default roles method
      this.getAllDefaultRoles();
    },
    firstPagination() {
      // setting spinner to true
      this.isBusyDefault = true;

      var newDefaultSystemRolesObj = this.getDefaultSystemRolesObj;
      newDefaultSystemRolesObj.pageNumber = this.pageNoDefault;

      // update settings store getDefaultSystemRolesObj
      this.$store.commit('settings/SET_DEFAULT_SYSTEM_ROLES_OBJ', newDefaultSystemRolesObj);
      this.getAllDefaultRoles();
    },
    prevPagination() {
      // setting spinner to true
      this.isBusyDefault = true;

      var newDefaultSystemRolesObj = this.getDefaultSystemRolesObj;
      newDefaultSystemRolesObj.pageNumber = newDefaultSystemRolesObj.pageNumber--;

      // update settings store getDefaultSystemRolesObj
      this.$store.commit('settings/SET_DEFAULT_SYSTEM_ROLES_OBJ', newDefaultSystemRolesObj);
      this.getAllDefaultRoles();
    },
    nextPagination() {
      // setting spinner to true
      this.isBusyDefault = true;

      var newDefaultSystemRolesObj = this.getDefaultSystemRolesObj;
      newDefaultSystemRolesObj.pageNumber = newDefaultSystemRolesObj.pageNumber++;

      // update settings store getDefaultSystemRolesObj
      this.$store.commit('settings/SET_DEFAULT_SYSTEM_ROLES_OBJ', newDefaultSystemRolesObj);
      this.getAllDefaultRoles();
    },
    lastPagination() {
      // setting spinner to true
      this.isBusyDefault = true;

      var newDefaultSystemRolesObj = this.getDefaultSystemRolesObj;
      newDefaultSystemRolesObj.pageNumber = Math.ceil(newDefaultSystemRolesObj.selectedRecordCount / this.filterRecordsPerScreen);

      // update settings store getDefaultSystemRolesObj
      this.$store.commit('settings/SET_DEFAULT_SYSTEM_ROLES_OBJ', newDefaultSystemRolesObj);
      this.getAllDefaultRoles();
    },
    getAllDefaultRoles() {
      this.$store
        .dispatch('settings/fetchDefaultSystemRoles', {
          params: {
            pg_num: this.getDefaultSystemRolesObj.pageNumber,
            pg_size: this.getDefaultSystemRolesObj.pageSize,
          },
          body: {
            client_role_id: 0,
            client_id: +this.getUserClients.client,
            role_id: 0,
            name: '',
            description: '',
            is_custom: false,
            allow_admin_access: null,
            overwrite_unit_roles: null,
          },
        })
        .then(() => {
          this.isBusyDefault = false;
        })
        .catch(() => {
          console.log('from getAllDefaultRoles method');
        });
    },
    onChangeRecordsPerScreenCustom() {
      // setting spinner to true
      this.isBusyCustom = true;

      var newCustomSystemRolesObj = this.getCustomSystemRolesObj;
      newCustomSystemRolesObj.pageSize = this.filterRecordsPerScreenCustom;

      // update settings store getCustomSystemRolesObj
      this.$store.commit('settings/SET_CUSTOM_SYSTEM_ROLES_OBJ', newCustomSystemRolesObj);

      // calling the get all default roles method
      this.getAllCustomRoles();
    },
    firstPaginationCustom() {
      // setting spinner to true
      this.isBusyCustom = true;

      var newCustomSystemRolesObj = this.getCustomSystemRolesObj;
      newCustomSystemRolesObj.pageNumber = this.pageNoCustom;

      // update settings store getCustomSystemRolesObj
      this.$store.commit('settings/SET_CUSTOM_SYSTEM_ROLES_OBJ', newCustomSystemRolesObj);
      this.getAllCustomRoles();
    },
    prevPaginationCustom() {
      // setting spinner to true
      this.isBusyCustom = true;

      var newCustomSystemRolesObj = this.getCustomSystemRolesObj;
      newCustomSystemRolesObj.pageNumber = newCustomSystemRolesObj.pageNumber--;

      // update settings store getCustomSystemRolesObj
      this.$store.commit('settings/SET_DEFAULT_SYSTEM_ROLES_OBJ', newCustomSystemRolesObj);
      this.getAllDefaultRoles();
    },
    nextPaginationCustom() {
      // setting spinner to true
      this.isBusyCustom = true;

      var newCustomSystemRolesObj = this.getCustomSystemRolesObj;
      newCustomSystemRolesObj.pageNumber = newCustomSystemRolesObj.pageNumber++;

      // update settings store getCustomSystemRolesObj
      this.$store.commit('settings/SET_DEFAULT_SYSTEM_ROLES_OBJ', newCustomSystemRolesObj);
      this.getAllDefaultRoles();
    },
    lastPaginationCustom() {
      // setting spinner to true
      this.isBusyCustom = true;

      var newCustomSystemRolesObj = this.getCustomSystemRolesObj;
      newCustomSystemRolesObj.pageNumber = Math.ceil(newCustomSystemRolesObj.selectedRecordCount / this.filterRecordsPerScreenCustom);

      // update settings store getCustomSystemRolesObj
      this.$store.commit('settings/SET_DEFAULT_SYSTEM_ROLES_OBJ', newCustomSystemRolesObj);
      this.getAllDefaultRoles();
    },
    getAllCustomRoles() {
      // updating record per screen for custom
      this.filterRecordsPerScreenCustom = this.getCustomSystemRolesObj.pageSize;

      this.$store
        .dispatch('settings/fetchCustomSystemRoles', {
          params: {
            pg_num: this.getCustomSystemRolesObj.pageNumber,
            pg_size: this.getCustomSystemRolesObj.pageSize,
          },
          body: {
            client_role_id: 0,
            client_id: +this.getUserClients.client,
            role_id: 0,
            name: '',
            description: '',
            is_custom: true,
            allow_admin_access: null,
            overwrite_unit_roles: null,
          },
        })
        .then(() => {
          this.isBusyCustom = false;
        })
        .catch(() => {
          console.log('from getAllCustomRoles method');
        });
    },
    setActiveMenuItem: function() {
      this.$store.dispatch('adminSidebar/setActive', {
        activeMenuItem: this.activeMenuItem ? this.activeMenuItem : 'rolesAndPermissions',
        activeMenu: this.activeMenu ? this.activeMenu : 'settings',
      });
    },
    deleteClientRoleByClientRoleId(clientRoleId) {
      this.$confirm({
        title: 'Delete Role',
        content: 'This role will be permanently deleted and cannot be recovered. Are you sure?',
        okText: 'Delete',
        okType: 'danger',
        cancelText: 'Cancel',
        onOk: () => {
          this.$store
            .dispatch('settings/deleteClientRoleByClientId', {
              clientroleid: clientRoleId,
            })
            .then(() => {
              this.$store.commit('systemMessage/SET_MODAL_MESSAGE', 'Successfully deleted.');
              this.getAllCustomRoles();
            })
            .catch(() => {
              console.log('error from deleteClientRoleByClientRoleId vue');
            });
        },
      });
    },
    editClientRoleById(clientRoleId) {
      console.log(clientRoleId, 'crd');
    },
  },

  computed: {
    filterRecordsPerScreenOptions() {
      return this.$store.getters['settings/getFilterRecordsPerScreenOptions'];
    },
    getDefaultSystemRolesObj() {
      return this.$store.getters['settings/getDefaultSystemRolesObj'];
    },
    getCustomSystemRolesObj() {
      return this.$store.getters['settings/getCustomSystemRolesObj'];
    },
    getUserClients() {
      return this.$store.getters['user/getUserClients'];
    },
  },
  watch: {},
  created() {
    this.isBusyDefault = true;
    this.isBusyCustom = true;
    this.getAllDefaultRoles();
    this.getAllCustomRoles();
    this.setActiveMenuItem();
  },
};
</script>
<style lang="scss">
.role-and-permissions {
  .buttonStyle {
    border-radius: 1.5rem;
  }
  .border table {
    margin-bottom: 0px !important;
  }
}
</style>
